var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "rejectModal",
      staticClass: "wp-reject-extension-modal",
      attrs: {
        title: _vm.$t("workPermit.rejctExtensionHint"),
        okBtnAction: "rejectAction",
        okBtnDisabled: _vm.isCommentEmpty,
        afterClose: _vm.resetData,
      },
      on: { onOkClick: _vm.rejectExtension },
    },
    [
      _c("TextField", {
        attrs: {
          label: _vm.$t("comment"),
          showColon: false,
          required: true,
          value: _vm.rejectComments,
          placeholder: _vm.$t("hint.typeRejectComment"),
        },
        on: { inputValue: _vm.updateComment },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }